module.exports = __webpack_public_path__ + "static/musee_olympique_stades4-f149f74a5bc652e0344a1c48eedd5c66.png";